<script>
import axios from '@/utils/axios';
// import { getStandardUnits, getDimensionalUnits } from '@/utils/units'
import { approverUsers } from '@/utils/user';
import { byDocumentType } from '@/utils/document-setting';
import { documentTemplates } from '@/utils/document-template';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';
import StatusBadge from '@/components/common/sales-order-status-badge.vue';
import DocumentPlaceholder from '@/components/common/proforma-placeholder.vue';
import { useMasterDataStore } from '@/stores/useMasterDataStore';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore';

export default {
  components: {
   StatusBadge, 
   DocumentPlaceholder  
  },
  inject: ['setLoading'],
  data() {
    return {
      id: '',
      ids: [],
      gst_no: '',
      proforma_invoice_id: null,
      modal_title: '',
      name: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      pincode: '',
      state: null,
      country: null,
      shipping_name: '',
      shipping_email: '',
      shipping_phone: '',
      shipping_address: '',
      shipping_city: '',
      shipping_pincode: '',
      shipping_state: null,
      shipping_country: null,
      selectedParty: null,
      status: null,
      tax_mode: null,
      selectedTax: null,
      selectedUnit: null,
      shipment_date: '',
      notes: '',
      tax_modes: ['item', 'order'],
      place_of_supply: '',
      // countries: [],
      taxes: [],
      parties: [],
      allItems: [],
      items: [
        { item: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }
      ],
      shipping_charges: 0,
      transport_name: '',
      delivery_method: '',
      discount: 0,
      states: [],
      shipping_states: [],
      loading: false,
      editorConfig: {
       toolbar: {
        items: ['bold', 'italic']
      },
      // 🔧 RESIZEOBSERVER FIX
      resize_enabled: false, 
      resize_image: {
        resizeOptions: [
          { name: 'resize-original', label: 'Original', value: null }
        ]
      }
      },
      editor: ClassicEditor,
      action: '',
      currency: '',
      mass_delete: false,
      party_type: '',
      activities: [],
      remark: '',
      users: [],
      approved_by: null,
      units: [],
      // standardUnits: [],
      // dimensionalUnits: [],
      assignment_history: [],
      is_shipping: false,
      errors: {},
      previewData: null,
      type: "sales_order",
      settings: {
       mail_subject: '',
       mail_body: '',
       mail_footer: '',
       terms: '',
       send_on_email: false,
      },
      templates: [],
      template: null,
      activities: [],
      so_number: '',
      remark: '',
      qcParameters: [],
      qcChecklist: {},
      qcItems: [],  
      qcLoading: false,
      tracking_number: '',
      document_template_id: null,
      should_send_mail: false,
      deliveryImage: null,
      deliveryImageUploading: false,
      deliveryUploadProgress: 0,
      deliveryImageError: null,
      is_editable: false,
      module_url: 'sales-orders',
    };
  },

  computed: {
  countries()        { return useMasterDataStore().countries || [] },
  standardUnits()    { return useMasterDataStore().standardUnits || [] },
  dimensionalUnits() { return useMasterDataStore().dimensionalUnits || [] },
   totalAmount(){
    return this.items.reduce((sum, row) => sum + row.amount, 0);
   },

   taxAmount() {
    if(this.tax_mode === 'order'){
     const tax_rate = this.selectedTax?.rate || 0;
     const taxable_amount = this.totalAmount - this.discount;
     return (taxable_amount * tax_rate) / 100;
    }else{
     // Item mode - sum taxes from individual items using selectedTax
     return this.items.reduce((sum, row) => {
      const itemTaxRate = row.selectedTax?.rate || 0;
      return sum + (row.amount * itemTaxRate / 100);
     }, 0);
    }
   },

   grandTotal(){
    const discountAmount = parseFloat(this.discount) || 0;
    const shippingAmount = parseFloat(this.shipping_charges) || 0;
    return Math.max(0, this.totalAmount - discountAmount) + this.taxAmount + shippingAmount;
   },

   showTaxInfo(){
    return !(this.tax_mode === 'item' && this.clientSetting?.tax_type === 'inclusive');
   },

savedQCCount() {
  if (!this.qcItems.length || this.qcLoading) return 0;
  return this.qcItems.filter(item => item.is_checked).length;
},
  

pendingQCCount() {
  if (!this.qcItems.length || this.qcLoading) return 0;
  return this.qcItems.length - this.savedQCCount;
},
  requiredPendingCount() {
    if (!this.qcParameters.length || this.qcLoading) return 0;
    return this.qcParameters.filter(param => 
      param.is_required && !this.hasQCValue(param.id)
    ).length;
  },
  
completionPercentage() {
  if (!this.qcItems.length || this.qcLoading) return 0;
  return Math.round((this.savedQCCount / this.qcItems.length) * 100);
},

  },

  mounted(){  
    this.loadMaster();
    // this.getCountries();
    // this.fetchUnits();
  },

  watch:{
   
   discount(newVal){
    if (this.totalAmount === 0 || !this.totalAmount) return;
    if(newVal < 0){
     this.discount = 0;
     this.$swalToast("Discount cannot be negative", 'warning');
    }else if(newVal > this.totalAmount){
     this.discount = this.totalAmount;
     this.$swalToast("Discount cannot exceed total amount", 'warning');
    }
   },

   party_type(newVal, oldVal){
    if(newVal !== oldVal && !this.id){
     // Clear selected party and party_id if type changed
      this.selectedParty = null;
     // If you store party_id separately:
      this.party_id = null;
     // Also clear parties array if you want
      this.parties = [];
    }
   },

  },

 methods: {
//  async fetchUnits(){
//     try{
//         const [standard, dimensional] = await Promise.all([
//             getStandardUnits(),
//             getDimensionalUnits()
//         ]);
//         this.standardUnits = standard;
//         this.dimensionalUnits = dimensional;
//     }catch(error){
//         this.$swalToast(error.message, 'error');
//     }
// },

async loadMaster(){
  await useMasterDataStore().loadAll()
},

getUnitFactor(unitValue){
    const unit = this.dimensionalUnits.find(u => u.value === unitValue);
    return unit?.factor || 1;
},

getItemGeneralError(index){
    const key = `items.${index}`;
    return this.errors[key] ? this.errors[key] : null;
},


async createFromProforma(proforma) {
  // Step 1: 
  await this.salesOrder(); 
   this.proforma_invoice_id = proforma.id;

  // Step 2: 
  if (proforma.party_type && proforma.party_id) {
    this.party_type = proforma.party_type;
    await this.getPartyById(proforma.party_type, proforma.party_id);
  }

  this.name    = proforma.to_name    || proforma.name    || '';
  this.email   = proforma.to_email   || proforma.email   || '';
  this.phone   = proforma.to_phone   || proforma.phone   || '';
  this.address = proforma.to_address || proforma.address || '';
  this.city    = proforma.to_city    || proforma.city    || '';
  this.pincode = proforma.to_pincode || proforma.pincode || '';
  this.gst_no  = proforma.gst_no     || '';

  // Country aur State
  if (proforma.to_country || proforma.country) {
    const countryName = proforma.to_country || proforma.country;
    this.country = this.countries.find(c => c.name === countryName) || null;
    if (this.country) await this.onCountrySelect(this.country);
  }
  if (proforma.to_state || proforma.state) {
    const stateName = proforma.to_state || proforma.state;
    this.state = this.states.find(s => s.name === stateName) || null;
  }

  // Step 3: Financial fields
  this.tax_mode         = proforma.tax_mode         || 'item';
  this.discount         = parseFloat(proforma.discount         || 0);
  this.shipping_charges = parseFloat(proforma.shipping_charges || 0);

  // Step 4: Notes & Terms
  this.notes          = proforma.notes  || '';
  this.settings.terms = proforma.terms  || '';

  // Step 5: Items map karo
  // Proforma 
  const sourceItems = proforma.proforma_items || [];

  if (sourceItems.length) {
    this.items = sourceItems.map(row => {
      const selectedItem = this.allItems.find(i => i.id === row.item_id)
                        || { id: row.item_id, name: row.name };
      const selectedTax  = row.tax_id
                        ? this.taxes.find(t => t.id === row.tax_id)
                        : null;
      const selectedUnit = row.unit
                        ? this.units.find(u => u === row.unit)
                        : null;
      const price = parseFloat(row.unit_price || row.price || 0);
      const qty   = parseFloat(row.quantity   || 1);

      return {
        item:         selectedItem,
        selectedTax:  selectedTax,
        selectedUnit: selectedUnit,
        description:  row.description || '',
        unit:         row.unit        || '',
        hsn_code:     row.hsn_code    || '',
        price:        price,
        qty:          qty,
        amount:       price * qty,
      };
    });
  }
},


 async saveQCAndUpdateStatus() {
  this.setLoading(true);
  try {
    const payload = this.getQCPayload();

    await axios.put(`/${this.module_url}/${this.id}/qc`, {
      qc_checklist: payload
    });

    // Close QC modal first
    this.$closeModal('sales_order_qc_status_modal');

    // Emit event to parent so it can open Update Status modal
    this.$emit('open-update-status', this.id);

  } catch (error) {
    if (error.type === 'validation') {
      this.errors = error.errors;
    } else {
      this.$swalToast(error.response?.data?.message || 'Failed to save QC status', 'error');
    }
  } finally {
    this.setLoading(false);
  }
},

  async handleDeliveryImageUpload(event) {
    const file = event.target.files[0];
    if (!file) return;
    
    this.validateDeliveryImage(file);
    await this.uploadDeliveryImage(file);
  },

  // Drag & drop
  handleImageDrop(event) {
    const file = event.dataTransfer.files[0];
    if (file) {
      this.$refs.deliveryImageInput.files = event.dataTransfer.files;
      this.validateDeliveryImage(file);
      this.uploadDeliveryImage(file);
    }
  },

  // Validate image
  validateDeliveryImage(file) {
    this.deliveryImageError = null;
    
    if (!file.type.startsWith('image/')) {
      this.deliveryImageError = 'Please select a valid image file';
      return false;
    }
    
    if (file.size > 5 * 1024 * 1024) { // 5MB
      this.deliveryImageError = 'Image size must be less than 5MB';
      return false;
    }
    
    return true;
  },

  // Upload delivery image
  async uploadDeliveryImage(file) {
    this.deliveryImageUploading = true;
    this.deliveryUploadProgress = 0;
    
    try {
      const formData = new FormData();
      formData.append('delivery_image', file);
      
      const response = await axios.post(
        `/${this.module_url}/${this.id}/delivery-image`, 
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            this.deliveryUploadProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }
        }
      );
      
      this.deliveryImage = response.data.image_url; 
      this.$swalToast('Delivery image uploaded successfully!', 'success');
      this.$emit('updated');
      this.$closeModal('sales_order_qc_status_modal');  
    } catch (error) {
      this.deliveryImageError = error.response?.data?.message || 'Upload failed';
      this.$swalToast(this.deliveryImageError, 'error');
    } finally {
      this.deliveryImageUploading = false;
      this.deliveryUploadProgress = 0;
    }
  },

  // Remove delivery image
 async removeDeliveryImage() {
  if (!this.deliveryImage) return;
  
  try {
    await axios.delete(`/${this.module_url}/${this.id}/delivery-image`);
    
    
    this.$nextTick(() => {
      this.deliveryImage = null;
    });
    
    this.$swalToast('Delivery image removed', 'success');
    this.$emit('updated');
    
    
  } catch (error) {
    this.$swalToast('Failed to remove image', 'error');
  }
},

  // Load existing delivery image
  async loadDeliveryImage() {
    try {
      const response = await axios.get(`/${this.module_url}/${this.id}/delivery-image`);
      if (response.data.image_url) {
        this.deliveryImage = response.data.image_url;
      }
    } catch (error) {
      console.log('No existing delivery image');
    }
  },

  // Reset delivery image
  resetDeliveryForm() {
    this.deliveryImage = null;
    this.deliveryImageUploading = false;
    this.deliveryUploadProgress = 0;
    this.deliveryImageError = null;
  },

async qcStatus(id, so_number, is_editable, deliveryImage = null) {
  this.id = id;
  this.so_number = so_number;
  this.is_editable = is_editable;
  this.qcLoading = true;
  this.qcItems = [];
  this.deliveryImage = null; 

  try {
    const response = await axios.get(`/${this.module_url}/${this.id}/edit`);
    const data = response.data.data;

    if (data.path) {
     this.deliveryImage = `${data.document_url}`;
      
    }

    this.qcItems = (data.sales_order_items || []).map(item => ({
      id: item.id,
      item_id: item.item_id,
      name: item.name,
      description: item.description,
      qty: item.quantity,
      unit: item.unit,
      unit_price: item.unit_price,
      is_checked: item.is_checked ?? false,
      remark: item.remark || '',
    }));

    this.$nextTick(() => {
      this.$openModal('sales_order_qc_status_modal');
    });

  } catch (error) {
    this.$swalToast('Failed to load QC data', 'error');
  } finally {
    this.qcLoading = false;
  }
},

updateQCItem(index, field, value) {
  if (!this.is_editable) return;
  this.qcItems[index][field] = value;
},

async saveQCStatus() {
  this.setLoading(true);
  try {
    const payload = this.qcItems.map(item => ({
      id: item.id,
      is_checked: item.is_checked,
      remark: item.remark,
    }));

    await axios.put(`/${this.module_url}/${this.id}/qc`, {
      items: payload
    });

    this.$swalToast('QC Status updated successfully!', 'success');
    this.$closeModal('sales_order_qc_status_modal');
    this.$emit('updated');

  } catch (error) {
    this.$swalToast(error.response?.data?.message || 'Failed to save QC status', 'error');
  } finally {
    this.setLoading(false);
  }
},

async saveQCAndUpdateStatus() {
  this.setLoading(true);
  try {
    const payload = this.qcItems.map(item => ({
      id: item.id,
      is_checked: item.is_checked,
      remark: item.remark,
    }));

    await axios.put(`/${this.module_url}/${this.id}/qc`, {
      items: payload
    });

    this.$closeModal('sales_order_qc_status_modal');
    this.$emit('open-update-status', this.id);

  } catch (error) {
    this.$swalToast(error.response?.data?.message || 'Failed to save QC status', 'error');
  } finally {
    this.setLoading(false);
  }
},

resetQCForm() {
  this.qcItems = [];
  this.qcLoading = false;
},

 async loadAllQCParameters() {
  try {
    this.qcLoading = true;
    const response = await axios.get('/qc-parameters');  
    this.qcParameters = response.data.data;
    
    // Initialize qcChecklist for ALL parameters
    this.qcChecklist = {};
    this.qcParameters.forEach(param => {
      const key = param.id.toString();
      this.qcChecklist[key] = {
        id: param.id,
        value: 'Yes',  
        remark: '',
        is_checked: false
      };
    });
    
  } catch (error) {
    console.error('Load all QC params error:', error);
    this.$swalToast('Failed to load QC parameters', 'error');
  } finally {
    this.qcLoading = false;
  }
 },

//  async saveQCStatus() {
//   this.setLoading(true);
//   try {
//     const payload = this.getQCPayload();
    
//     await axios.put(`/${this.module_url}/${this.id}/qc`, {
//       qc_checklist: payload
//     });
    
//     this.$swalToast('QC Status updated successfully!', 'success');
//     this.$closeModal('sales_order_qc_status_modal');
//     this.$emit('updated');
    
//   } catch (error) {
//     if (error.type === 'validation') {
//       this.errors = error.errors;
//     } else {
//       this.$swalToast(error.response?.data?.message || 'Failed to save QC status', 'error');
//     }
//   } finally {
//     this.setLoading(false);
//   }
//  },

 hasQCValue(paramId) {
  const qc = this.qcChecklist[String(paramId)];
  return !!(qc && qc.value && qc.value.toString().trim() !== '');
 },

 async loadSavedQC() {
  try {
    const response = await axios.get(`/${this.module_url}/${this.id}/edit`);
    const data = response.data.data;
    
    if(data.checklists && data.checklists.length) {
      //this.qcChecklist = {};
      
      data.checklists.forEach(qc => {
        // USE QC PARAMETER ID as KEY (matches qcParameters[param.id])
        this.qcChecklist[qc.q_c_parameter_id.toString()] = {
          id: qc.q_c_parameter_id,        // QC Parameter ID: 1, 2
          value: qc.value || 'Yes',        // "150"
          remark: qc.remark || '',
          is_checked: qc.is_checked,
        };
      });
    }
  } catch(error) {
    console.log('No saved QC found');
  }
 },

  // NEW: Get QC Error for specific parameter
 getQCError(paramId, index = 0) {
  const qcIndex = Object.values(this.qcChecklist).findIndex(qc => qc.id == paramId);
  if (qcIndex === -1) return null;
  
  const errorKey = `qc_checklist.${qcIndex}.value`;
  return this.errors[errorKey] ? this.errors[errorKey][index] : null;
 },

 getQCPayload() {
  return this.qcParameters.map(param => {
    const qc = this.qcChecklist[param.id.toString()];
    return {
      id: param.id,
      value: qc?.value ?? null,
      remark: qc?.remark ?? null,
      is_checked: qc?.is_checked ?? false
    };
  });
 },

  updateQC(paramId, field, value) {
   if (!this.is_editable) return;
    const idStr = paramId.toString();
    if (!this.qcChecklist[idStr]) {
      this.qcChecklist[idStr] = {
        id: parseInt(paramId),
        is_checked: false,
        value: 'Yes',
        remark: '',
      };
    }
    this.qcChecklist[idStr][field] = value;
  },
  
  getQCValue(paramId) {
   const key = paramId.toString();
   // RETURN DEFAULT if not exists (prevents undefined errors)
   return this.qcChecklist[key] || { value: null, remark: '', is_checked: false };
  },

  async loadQCParameters() {
   try {
    this.qcLoading = true;
    const response = await axios.get('/qc-parameters/sales-order');
    this.qcParameters = response.data.data;
    
    this.qcChecklist = {};
    this.qcParameters.forEach(param => {
      const key = String(param.id);
      this.qcChecklist[key] = {
        id: param.id,
        value: 'Yes',
        remark: '',
        is_checked: false
      };
    });
   } catch (error) {
    this.$swalToast(error.message, 'error');
   } finally {
    this.qcLoading = false;
   }
  },

  async getUsers(){
   try{
    const response = await approverUsers();
    this.users = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  async allDocumentTemplates(){
   try{
    const response = await documentTemplates(this.type);
    this.templates = response.data.data;
    if(this.id){
     this.template = this.templates.find(t => t.id === this.document_template_id) || null;
    }else{
     // CREATE MODE: Use default document_template_id or first template
     const defaultTemplate = this.templates.find(t => t.id === this.document_template_id) || 
                             (this.templates.length > 0 ? this.templates[0] : null);
     this.template = defaultTemplate;
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async byType(type){
   this.setLoading(true);
   try{
    const response = await byDocumentType(type, this.clientAdmin?.id);
    const data = response.data.data;
    this.settings = {
     mail_subject: data?.mail_subject || '',
     mail_body: data?.mail_body || '',
     mail_footer: data?.mail_footer || '',
     terms: data?.terms || '',
     send_on_email: data?.send_on_email || false
    };
    this.document_template_id = data?.document_template_id;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  // async getCountries(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('/countries');
  //   this.countries = response.data.data;
  //  }catch(error){
  //   this.$swalToast(error.message, 'error');
  //  }finally{
  //   this.setLoading(false);
  //  } 
  // },

  async salesOrderActivity(row){
   this.status = row.status;
   this.so_number = row.so_number;
   this.remark = row.remark;
   this.tracking_number = row.tracking_number; 
   this.activities = row.activities;
  },

  async salesOrder(public_token = null){
   this.getUsers(); 
   this.setLoading(true);
   try{
    this.resetForm();
    this.getTaxes();
    this.getAllItems();
    this.byType(this.type);
    this.allDocumentTemplates();
    this.tax_mode = 'item';
    this.party_type = `App\\Models\\Customer`;

    if (!this.qcParameters.length) {
     await this.loadQCParameters();
    }

   if(public_token !== null){

    await this.getAllItems(); 

    const response = await axios.get(`/${this.module_url}/${public_token}`);
    const data = response.data.data;
    this.status = data.status;
    this.document_template_id = data.document_template_id;

    await this.getPartyById(data.party_type, data.party_id);

    this.id = data.id;
    this.approved_by = data.approved_by;
    this.gst_no = data.gst_no;
    this.name = data.name;
    this.email = data.email;
    this.phone = data.phone;
    this.city = data.city;
    this.address = data.address;
    this.pincode = data.pincode;
    this.party_type = data.party_type;
    this.country = (data.country != '') ? this.countries.find(c => c.name === data.country) : null;
    if(this.country?.id) await this.onCountrySelect(this.country);
    this.state = (data.state != '') ? this.states.find(s => s.name === data.state) : null;
    this.shipping_name = data.shipping_name;
    this.shipping_email = data.shipping_email;
    this.shipping_phone = data.shipping_phone;
    this.shipping_address = data.shipping_address;
    this.shipping_city = data.shipping_city;
    this.shipping_pincode = data.shipping_pincode;
    this.shipping_state = (data.shipping_state != '') ? this.shipping_states.find(s => s.name === data.shipping_state) : null;
    this.shipping_country = (data.shipping_country != '') ? this.countries.find(c => c.name === data.shipping_country) : null;
    this.tax_mode = data.tax_mode;
    this.shipment_date = data.shipment_date;
    this.place_of_supply = data.place_of_supply;
    this.settings.terms = data.terms || '';
    this.notes = data.notes || '';
    this.selectedTax = this.taxes.find(t => t.id === data.tax_id) || null;
    this.discount = parseFloat(data.discount || 0);
    this.shipping_charges = parseFloat(data.shipping_charges || 0);
    this.transport_name = data.transport_name || '';
    this.delivery_method = data.delivery_method || '';

    await this.allDocumentTemplates();
    await this.loadSavedQC();

    // Populate items
    this.items = data.sales_order_items.map(row => {
    const selectedItem = this.allItems.find(i => i.id === row.item_id);
    const unitPrice = parseFloat(row.unit_price || row.price || 0);
    const qty = parseFloat(row.quantity || 1);
    const selectedTax = row.tax_id ? this.taxes.find(t => t.id === row.tax_id) : null;
    const calcType = selectedItem?.calculation_type || 'standard';
    const availableUnits = calcType === 'dimensional' ? this.dimensionalUnits : this.standardUnits;
    const selectedUnit = row.unit ? availableUnits.find(u => u.value === row.unit) : null;

    return {
        item: selectedItem || { id: row.item_id, name: row.name },
        selectedTax: selectedTax,
        selectedUnit: selectedUnit,
        description: row.description || '',
        unit: row.unit || '',
        hsn_code: row.hsn_code || '',
        price: unitPrice,
        originalPrice: unitPrice,
        qty: qty,
        amount: 0,
        calculation_type: calcType,
        width: parseFloat(row.width || 0),
        height: parseFloat(row.height || 0),
        base_unit: selectedItem?.unit || '',
        availableUnits: availableUnits,
        size: 0,
        conversion_factor: 0,
        conversion_rate: 0,
        rmt_width_multiplier: selectedItem?.rmt_width_multiplier || parseFloat(row.rmt_width_multiplier || 1),
        rmt_height_multiplier: selectedItem?.rmt_height_multiplier || parseFloat(row.rmt_height_multiplier || 1),
    };
});
this.items.forEach((_, index) => {
    this.updateAmount(index);
});
    }
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async getPartyById(party_type, id){
   try{
    let res;
    if(party_type === `App\\Models\\Lead`){
     res = await axios.get(`/leads/${id}`);
    }else{
     res = await axios.get(`/customers/${id}`);
    }
    this.selectedParty = res.data.data;
    this.onPartySelected(this.selectedParty);
   }catch(err){
    this.$swalToast("Party not found", 'error');
   }
  },

   async getAllItems(){
    try{
     const res = await axios.get('/items/dropdown');
     this.allItems = res.data.data;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },
    
   addItemRow(){
    this.items.push({ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0, calculation_type: 'standard', width: 0, height: 0, base_unit: '', availableUnits: this.standardUnits, size: 0, conversion_factor: 0, conversion_rate: 0, rmt_width_multiplier: 1, rmt_height_multiplier: 1, originalPrice: 0 });
},
   
   removeItemRow(index){
    if (this.items.length === 1) return;
    this.items.splice(index, 1);
   },

onItemSelected(index, selectedItem){
    const row = this.items[index];
    if(!selectedItem){
        row.item = null;
        row.selectedTax = null;
        row.selectedUnit = null;
        row.description = '';
        row.unit = '';
        row.hsn_code = '';
        row.price = 0;
        row.qty = 1;
        row.amount = 0;
        return;
    }

    row.description = selectedItem.description || '';
    row.unit = selectedItem.unit || '';
    row.hsn_code = selectedItem.hsn_code || '';
    row.price = parseFloat(selectedItem.price || 0);
    row.qty = 1;

    if(selectedItem.tax_id){
        row.selectedTax = this.taxes.find(t => t.id === selectedItem.tax_id);
        row.item.tax = row.selectedTax;
    }else{
        row.selectedTax = null;
        row.item.tax = null;
    }

    row.calculation_type = selectedItem.calculation_type || 'standard';
    row.width = 0;
    row.height = 0;

    if(row.calculation_type === 'dimensional'){
        row.availableUnits = this.dimensionalUnits;
        if(selectedItem.unit){
            row.selectedUnit = this.dimensionalUnits.find(u => u.value === selectedItem.unit) || null;
            row.unit = selectedItem.unit;
            row.base_unit = selectedItem.unit;
            row.rmt_width_multiplier = selectedItem.rmt_width_multiplier || 1;
            row.rmt_height_multiplier = selectedItem.rmt_height_multiplier || 1;
        }else{
            row.selectedUnit = null;
            row.base_unit = '';
        }
    }else{
        row.availableUnits = this.standardUnits;
        if(selectedItem.unit){
            row.selectedUnit = this.standardUnits.find(u => u.value === selectedItem.unit) || null;
            row.unit = selectedItem.unit;
        }else{
            row.selectedUnit = null;
        }
    }

    row.originalPrice = parseFloat(selectedItem.price || 0);
    this.updateAmount(index);
},

   updateAmount(index){
    const row = this.items[index];
    row.qty = Math.max(1, parseFloat(row.qty) || 1);
    const price = parseFloat(row.price) || 0;

    if(row.calculation_type === 'dimensional'){
        const width = parseFloat(row.width) || 0;
        const height = parseFloat(row.height) || 0;
        const qty = row.qty;
        const base_unit = row.base_unit || '';
        const selected_unit = row.unit || base_unit;

        if(selected_unit === 'Rmt'){
            const rmt_w = parseFloat(row.rmt_width_multiplier) || 1;
            const rmt_h = parseFloat(row.rmt_height_multiplier) || 1;
            const size = (((width / 1000) * rmt_w) + ((height / 1000) * rmt_h)) * qty;
            row.size = size;
            row.conversion_factor = 1;
            row.conversion_rate = price;
            row.amount = parseFloat((price * size).toFixed(2));
        } else {
            const base_factor = this.getUnitFactor(base_unit);
            const selected_factor = this.getUnitFactor(selected_unit);
            const size_in_sqmtr = (width / 1000) * (height / 1000) * qty;
            const size = size_in_sqmtr * selected_factor;
            const conversion_factor = selected_factor / base_factor;
            const conversion_rate = price / conversion_factor;
            row.size = size;
            row.conversion_factor = conversion_factor;
            row.conversion_rate = conversion_rate;
            row.amount = parseFloat((conversion_rate * size).toFixed(2));
        }
    } else {
        row.amount = row.qty * price;
    }
},

   async onCountrySelect(country){
    this.state = null;
    this.states = [];
     if(country?.id){
      try{
       const response = await axios.get(`/states/${country.id}`);
       this.states = response.data.data;
      }catch(error){
       this.$swalToast(error.message, 'error');
      }
     }
    },

   async onShippingCountrySelect(country){
    this.shipping_state = null;
    this.shipping_states = [];
    if(country?.id){
     try{
      const response = await axios.get(`/states/${country.id}`);
      this.shipping_states = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    }
   },

  
    async onSearch(search){
     if(!search || search.length < 2) return;
     this.loading = true;
     try{
      let res;
      if(this.party_type === "App\\Models\\Lead"){
       res = await axios.get('/leads/dropdown', { params: { search_keyword: search } });
      }else if(this.party_type === "App\\Models\\Customer") {
       res = await axios.get('/customers/dropdown', { params: { search_keyword: search } });
      }
      this.parties = res.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.loading = false;
     }
    },

   async onPartySelected(row){
     this.email = row?.email || '';
     this.phone = row?.mobile || '';
     this.gst_no = row?.gst_no || '';
     this.name = row?.company_name || row?.name;
     this.address = row?.address || '';
     this.city = row?.city || '';
     this.pincode = row?.pincode || '';
     if(row?.country !== '' || row?.country !== null){
      this.country = this.countries.find(c => c.name === row?.country);
      await this.onCountrySelect(this.country);
     }
     this.state = (row?.state != '') ? this.states.find(s => s.name === row?.state) : null;
     this.shipping_email = row?.email || '';
     this.shipping_phone = row?.mobile || '';
     this.shipping_name =  row?.name || row?.company_name;
     this.shipping_address = row?.shipping_address || '';
     this.shipping_city = row?.shipping_city || '';
     this.shipping_pincode = row?.shipping_pincode || '';
     if(row?.country !== '' || row?.country !== null){
      this.shipping_country = this.countries.find(c => c.name === row?.country);
      await this.onShippingCountrySelect(this.shipping_country);
     }
     this.shipping_state = (row?.state != '') ? this.shipping_states.find(s => s.name === row?.state) : null;
     this.currency = row?.currency?.code || '';
    },

    async getTaxes(){
     this.setLoading(true);
     try{
      const response = await axios.get('/taxes');
      this.taxes = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    async saveSalesOrder(shouldDownload = false, emitUpdate = true) {
     this.errors = {};
     this.setLoading(true);
      try{ 
       const payload = {
        proforma_invoice_id: this.proforma_invoice_id, 
        approved_by: this.approved_by,
        party_type: this.party_type,
        party_id: this.selectedParty?.id,
        gst_no: this.gst_no,
        name: this.name,
        email: this.email,
        phone: this.phone,
        address: this.address,
        city: this.city,
        pincode: this.pincode,
        state: this.state?.name,
        country: this.country?.name,
        shipping_name: this.name,
        shipping_email: this.email,
        shipping_phone: this.phone,
        shipping_address: this.shipping_address,
        shipping_city: this.shipping_city,
        shipping_pincode: this.shipping_pincode,
        shipping_state: this.shipping_state?.name,
        shipping_country: this.shipping_country?.name,
        is_shipping: this.is_shipping,
        place_of_supply: this.place_of_supply, 
        shipment_date: this.shipment_date,
        document_template_id: this.template?.id || null,
        terms: this.settings.terms,
        notes: this.notes,
        tax_mode: this.tax_mode,
        tax_id: this.selectedTax?.id || null,
        discount: this.discount,
        shipping_charges: this.shipping_charges,
        transport_name: this.transport_name,
        delivery_method: this.delivery_method,
        qc_checklist: this.getQCPayload(),
        items: this.items.map(row => ({
            item_id: row.item?.id || null,
            name: row.item?.name,
            description: row.description,
            unit: row.unit,
            hsn_code: row.hsn_code === 'null' || row.hsn_code === '' || row.hsn_code == null ? null : row.hsn_code,
            quantity: row.qty,
            unit_price: row.price,
            tax_id: row.selectedTax?.id || null,
            width: row.calculation_type === 'dimensional' ? row.width : null,
            height: row.calculation_type === 'dimensional' ? row.height : null,
            rmt_width_multiplier: row.unit === 'Rmt' ? row.rmt_width_multiplier : null,
            rmt_height_multiplier: row.unit === 'Rmt' ? row.rmt_height_multiplier : null,
        }))
       };

       let response;
       if(this.id){
        response = await axios.put(`/${this.module_url}/${this.id}/update`, payload);
       }else{
        response = await axios.post(`/${this.module_url}/create`, payload);
       }

       if(emitUpdate){
        this.$swalToast(response.data.message);
       }
       this.$emit('updated');
       

      // SAVE AND DOWNLOAD TRIGGER 
       if(shouldDownload){
        const documentId = this.id || response.data.data?.id;
        if(documentId){
         await downloadPDFUtil(this.module_url, documentId);
        }
       }

if(emitUpdate){
  this.$closeModal('sales_order_modal');
  this.resetForm();
} else {
  this.$closeModal('sales_order_modal'); 
}

       // SAVE AND SEND TRIGGER
       if(this.should_send_mail){
        const sales_order = response.data.data;
        this.$openModal('sales_order_mail_modal');
        this.mailSalesOrder(sales_order);
       }

      }catch(error){
       if(error?.type === 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async deleteSalesOrder(){
     this.errors = {};
     this.setLoading(true); 
     try{
      const response = await axios.delete(`/${this.module_url}/${this.id}/delete`);
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('sales_order_delete_modal');
     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
    },

    getItemError(index, field){
     const key = `items.${index}.${field}`;
     return this.errors[key] ? this.errors[key][0] : null;
    },

    getItemAmountDisplay(item) {
     if(this.tax_mode === 'item'){
      if(this.clientSetting?.tax_type === 'inclusive'){
       return item.amount;
      }else{
       if(item.item?.tax){
        return item.amount * (1 + (item.item.tax.rate / 100));
       }
       return item.amount;
      }
     }
     return item.amount;
    },

    salesOrderAction(id, action){
     this.id = id; 
     this.action = action;
    },

    bulkAction(ids){
     this.ids = ids;
    },

    async submitBulkAction() {
     const result = await this.$confirm({});
     if(result.isConfirmed){
      this.setLoading(true); 
     try{
      const response = await axios.post(`/${this.module_url}/bulk-actions`, {
       ids: this.ids,
       mass_delete: this.mass_delete,
       status: this.status || '',
      });
      this.$swalToast(response.data.message);
      this.$emit('updated');
      this.$closeModal('bulk_action_sales_order');
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
     }
    },

    // async getAllUsers(){
    //  try{
    //  const response = await axios.get('/users/all-users');
    //  this.users = response.data.data; 
    //  }catch(error){
    //   console.log(error.message);
    //  } 
    // },

    async getAllUsers(){
  await useLeadMetaStore().loadAll()
},

    async assignHistory(id, so_number){
     this.id = id;
     this.modal_title = so_number;
     await this.getAllUsers();
     this.setLoading(true);
     try{
      const response = await axios.get(`/${this.module_url}/${id}/assignment/history`);
      this.assignment_history = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    createViaParty(party_type, party_id){
     this.salesOrder(); 
     this.party_type = party_type;
     this.getPartyById(party_type,party_id);
    },

   onItemTaxSelected(index, selectedTax){
    const row = this.items[index];
    row.selectedTax = selectedTax;
  
    // Update the item's tax reference for calculations
    if(selectedTax){
     row.item = row.item || {};
     row.item.tax = selectedTax;
     row.item.tax_id = selectedTax.id;
    }else{
     if (row.item) {
      row.item.tax = null;
      row.item.tax_id = null;
     }
    }
    // Recalculate amount if needed
    this.updateAmount(index);
   },
   
   onItemUnitSelected(index, selectedUnit){
    const row = this.items[index];
    row.selectedUnit = selectedUnit;
    if(selectedUnit){
        row.unit = selectedUnit.value;
    }else{
        row.unit = '';
    }
    this.updateAmount(index);
},

   async save(){
    await this.saveSalesOrder(false);
   },
  
   async saveAndDownload(){
    await this.saveSalesOrder(true); 
   },

   async saveAndSend(){
    this.should_send_mail = true;
    await this.saveSalesOrder(false);
   },

async saveAndApprove(){
  try{
    const savedId = this.id; 
    await this.saveSalesOrder(false, false);
    this.$emit('approve-after-save', savedId);
  }catch(error){
    console.error('Approve after save failed', error);
  }
},

async saveAndReject(){
  try{
    const savedId = this.id; 
    await this.saveSalesOrder(false, false);
    this.$emit('reject-after-save', savedId);
  }catch(error){
    console.error('Reject after save failed', error);
  }
},
    
    // ##############################
    //  *** MAIL FUNCTIONS START ***
    // ##############################
    
      async mailSalesOrder(row){ 
       this.id = row.id; 
       this.modal_title = row.so_number;
       this.email = row.email;
       await this.byType(this.type);
      },
    
      async sendMail(){
       this.errors = {};
       this.setLoading(true);
       try{
        const payload = {
          email: this.email,
          mail_subject: this.settings.mail_subject,
          mail_body: this.settings.mail_body,
          mail_footer: this.settings.mail_footer
        };
         const response = await axios.post(`/${this.module_url}/${this.id}/email`, payload);
         this.$swalToast(response.data.message);
         this.$emit('updated');
         this.$closeModal('sales_order_mail_modal');
         this.resetForm();
        }catch(error){
        if(error.type === 'validation'){
         this.errors = error.errors;
        }else{
         this.$swalToast(error.message, 'error');
        }
        }finally{
         this.setLoading(false);
       } 
      },
    
    // ##############################
    //  *** MAIL FUNCTIONS END ***
    // ##############################

    resetForm() {
     this.id = null;
     this.proforma_invoice_id = null;
     this.name = '';
     this.email = '';
     this.phone = '';
     this.address = '';
     this.city = '';
     this.pincode = '';
     this.state = null;
     this.country = null;
     this.shipping_name = '';
     this.shipping_email = '';
     this.shipping_phone = '';
     this.shipping_address = '';
     this.shipping_city = '';
     this.shipping_pincode = '';
     this.shipping_state = null;
     this.shipping_country = null;
     this.shipment_date = '';
     this.gst_no = '';
     this.settings.terms = '';
     this.notes = '';
     this.party_type = '';
     this.selectedParty = null;
     this.status = null;
     this.tax_mode = null;
     this.selectedTax = null;
     this.place_of_supply = '';
     this.items = [{ item: null, selectedTax: null, selectedUnit: null, description: '', unit: '', hsn_code: '', price: 0, qty: 1, amount: 0 }];
     this.discount = 0;
     this.shipping_charges = 0;
     this.transport_name = '';
     this.delivery_method = '';
     this.errors = {};
    }
  }
};
</script>


<style scoped>
/* ─────────────────────────────────────────────
   SALES ORDER MODAL — QUOTATION-STYLE UI
   All logic is untouched. Only visual styles.
───────────────────────────────────────────── */
 
/* Main area */
.qm-main {
  flex: 1; display: flex; flex-direction: column; overflow: hidden;
  background: #f1f5f9;
}
 
/* Topbar */
.qm-topbar {
  background: #fff; border-bottom: 1px solid #e2e8f0;
  padding: 12px 22px;
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.qm-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.qm-page-sub { font-size: 11px; color: #94a3b8; }
.qm-close-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #f1f5f9; border: 1px solid #ef4444;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 13px; transition: all .15s;
  color: #ef4444;
}
.qm-close-btn:hover { background: #fee2e2; border-color: #fca5a5; color: #ef4444; }
 
/* Scrollable body */
.qm-body {
  flex: 1; overflow-y: auto; padding: 18px 22px;
  scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.qm-body::-webkit-scrollbar { width: 4px; }
.qm-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
 
/* Section cards */
.qm-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; margin-bottom: 14px; overflow: visible;
}
.qm-card-head {
  display: flex; align-items: center; gap: 9px;
  padding: 10px 16px; background: #f8fafc;
  border-bottom: 1px solid #e8edf3;
}
.qm-card-icon {
  width: 24px; height: 24px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.qm-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.qm-card-body { padding: 14px 16px; }
 
/* Form controls */
.qm-label {
  font-size: 11px; font-weight: 600; color: #475569;
  margin-bottom: 4px; display: block;
}
.qm-label .req { color: #f43f5e; margin-left: 2px; }
.qm-input, .qm-select, .qm-textarea {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 11px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.qm-input, .qm-select { height: 35px; }
.qm-textarea { padding: 8px 11px; resize: vertical; }
.qm-input:focus, .qm-select:focus, .qm-textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}
.qm-input.err { border-color: #f43f5e; box-shadow: 0 0 0 3px rgba(244,63,94,.1); }
.qm-select {
  appearance: none;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2394a3b8' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat right 10px center;
}
.qm-err-msg {
  font-size: 10.5px; color: #f43f5e; margin-top: 3px;
  display: flex; align-items: center; gap: 3px;
}
 
/* Item row */
.qm-item-card {
  background: #fff; border: 1.5px solid #e8edf3;
  border-radius: 10px; padding: 14px 14px 10px;
  margin-bottom: 10px; position: relative;
  transition: border-color .15s, box-shadow .15s;
}
.qm-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.qm-item-num {
  position: absolute; top: -9px; left: 14px;
  width: 19px; height: 19px; background: #3b82f6; color: #fff;
  border-radius: 50%; font-size: 9px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.qm-remove-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #fff0f3; border: 1.5px solid #fecdd3;
  color: #f43f5e; font-size: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.qm-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
 
/* Add item button */
.qm-add-item-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: #eff6ff;
  border: 1.5px dashed #93c5fd; border-radius: 8px;
  color: #2563eb; font-size: 11.5px; font-weight: 600;
  cursor: pointer; transition: all .15s;
}
.qm-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
 
/* Pricing summary */
.qm-price-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 7px 0; border-bottom: 1px dashed #f1f5f9;
}
.qm-price-row:last-of-type { border-bottom: none; }
.qm-price-label { font-size: 12px; color: #64748b; font-weight: 500; }
.qm-price-val { font-size: 12.5px; font-weight: 700; color: #1e293b; }
.qm-price-input-box {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 7px;
  overflow: hidden; width: 126px; background: #fff;
}
.qm-price-prefix {
  padding: 0 7px; font-size: 10px; font-weight: 600;
  color: #94a3b8; background: #f8fafc;
  border-right: 1.5px solid #e2e8f0;
  height: 30px; display: flex; align-items: center;
}
.qm-price-num-input {
  border: none; outline: none; width: 100%;
  text-align: right; font-size: 12px; font-weight: 600;
  color: #1e293b; padding: 0 8px; height: 30px; background: transparent;
}
.qm-grand-box {
  display: flex; align-items: center; justify-content: space-between;
  background: linear-gradient(135deg,#0f172a,#1e3a5f);
  border-radius: 10px; padding: 13px 18px; margin-top: 10px;
}
.qm-grand-label { font-size: 12.5px; font-weight: 700; color: #93c5fd; display: flex; align-items: center; gap: 6px; }
.qm-grand-val { font-size: 18px; font-weight: 800; color: #fff; letter-spacing: -.5px; }
 
/* Action footer */
.qm-footer {
  background: #fff; border-top: 1px solid #e2e8f0;
  padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0; flex-wrap: wrap;
}
 
/* Reusable buttons */
.qm-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 7px 15px; border-radius: 8px; font-size: 12px;
  font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
  transition: all .15s; text-decoration: none; white-space: nowrap;
}
.qm-btn-primary {
  background: linear-gradient(135deg,#2563eb,#3b82f6);
  color: #fff; border-color: #2563eb;
  box-shadow: 0 2px 8px rgba(37,99,235,.25);
}
.qm-btn-primary:hover { background: linear-gradient(135deg,#1d4ed8,#2563eb); }
.qm-btn-success { background: #fff; color: #16a34a; border-color: #86efac; }
.qm-btn-success:hover { background: #f0fdf4; border-color: #16a34a; }
.qm-btn-info { background: #fff; color: #0284c7; border-color: #bae6fd; }
.qm-btn-info:hover { background: #f0f9ff; border-color: #0284c7; }
.qm-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.qm-btn-ghost:hover { background: #f1f5f9; }
.qm-btn-danger { background: #f43f5e; color: #fff; border-color: #f43f5e; }
.qm-btn-danger:hover { background: #e11d48; border-color: #e11d48; }
.qm-btn-approve { background: #16a34a; color: #fff; border-color: #16a34a; }
.qm-btn-approve:hover { background: #15803d; border-color: #15803d; }
.qm-btn-reject { background: #f43f5e; color: #fff; border-color: #f43f5e; }
.qm-btn-reject:hover { background: #e11d48; border-color: #e11d48; }
 
/* vue-select theming */
:deep(.vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 35px !important; padding: 0 8px !important;
  transition: border-color .15s, box-shadow .15s !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
  font-size: 12px !important; color: #1e293b !important;
  background: #eff6ff !important; border: 1px solid #bfdbfe !important;
  border-radius: 5px !important;
}
</style>
 
 
<template>
 
<!-- ═══════════════════════════════════════════════
     ADD / EDIT SALES ORDER — FULLSCREEN MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="sales_order_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0;">
 
      <!-- ░░ MAIN CONTENT ░░ -->
      <div class="qm-main">
 
        <!-- Topbar -->
        <div class="qm-topbar">
          <div>
            <div class="qm-page-title">{{ id ? 'Edit Sales Order' : 'Create New Sales Order' }}</div>
            <div class="qm-page-sub">{{ id ? 'Update sales order details below' : 'Fill in the details to generate a new sales order' }}</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="qm-close-btn" data-bs-dismiss="modal">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
 
        <!-- Form -->
        <form @submit.prevent="saveSalesOrder(false)" class="d-flex flex-column" style="flex:1;overflow:hidden;">
 
          <div class="qm-body">
 
            <!-- ── 1. Sales Order Details ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#eff6ff;"><i class="ti ti-file-invoice" style="color:#3b82f6;"></i></div>
                <span class="qm-card-title">Sales Order Details</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
 
                  <div class="col-md-3">
                    <label class="qm-label">Client Type <span class="req">*</span></label>
                    <select class="qm-select" v-model="party_type">
                      <option value="">Choose any</option>
                      <option value="App\Models\Lead" :selected="party_type === `App\\Models\\Lead`">Lead</option>
                      <option value="App\Models\Customer" :selected="party_type === `App\\Models\\Customer`">Customer</option>
                    </select>
                    <div v-if="errors.party_type" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.party_type[0] }}</div>
                  </div>
 
                  <div class="col-md-3" v-if="party_type === `App\\Models\\Lead` || party_type === `App\\Models\\Customer`">
                    <label class="qm-label">Client <span class="req">*</span></label>
                    <vue-select v-model="selectedParty" :options="parties" :loading="loading" :filterable="false"
                      @search="onSearch" @update:modelValue="onPartySelected" label="name"
                      :placeholder="party_type === `App\\Models\\Lead` ? 'Search lead...' : 'Search customer...'"/>
                    <div v-if="errors.party_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.party_id[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">To</label>
                    <input type="text" class="qm-input" v-model="name" placeholder="Client name" />
                    <div v-if="errors.name" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.name[0] }}</div>
                  </div>
 
                  <div class="col-md-3">
                    <label class="qm-label">Email</label>
                    <input type="email" class="qm-input" v-model="email" placeholder="client@email.com" />
                    <div v-if="errors.email" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.email[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Phone No</label>
                    <input type="text" class="qm-input" v-model="phone" placeholder="+91 00000 00000" />
                    <div v-if="errors.phone" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.phone[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">GST No</label>
                    <input type="text" class="qm-input" v-model="gst_no" placeholder="22AAAAA0000A1Z5" />
                    <div v-if="errors.gst_no" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.gst_no[0] }}</div>
                  </div>
 
                  <div class="col-md-2" v-if="!id">
                    <label class="qm-label">Assign To</label>
                    <vue-select :options="users" label="name" placeholder="Approver" v-model="approved_by" :reduce="u => u.id" />
                    <div v-if="errors.approved_by" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.approved_by[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Shipment Date <span class="req">*</span></label>
                    <input type="date" class="qm-input" :class="{'err': errors.shipment_date}" v-model="shipment_date" />
                    <div v-if="errors.shipment_date" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.shipment_date[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Place of Supply</label>
                    <input type="text" class="qm-input" v-model="place_of_supply" />
                    <div v-if="errors.place_of_supply" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.place_of_supply[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Template <span class="req">*</span></label>
                    <vue-select :options="templates" label="name" v-model="template" placeholder="Choose template" />
                    <div v-if="errors.template_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.template_id[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Tax Mode <span class="req">*</span></label>
                    <vue-select :options="tax_modes" v-model="tax_mode"/>
                    <div v-if="errors.tax_mode" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_mode[0] }}</div>
                  </div>
 
                  <div class="col-md-2" v-if="tax_mode == 'order'">
                    <label class="qm-label">Tax</label>
                    <vue-select :options="taxes" label="name" placeholder="Select tax" v-model="selectedTax" />
                    <div v-if="errors.tax_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.tax_id[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Transport</label>
                    <input type="text" class="qm-input" v-model="transport_name" placeholder="Transport name" />
                    <div v-if="errors.transport_name" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.transport_name[0] }}</div>
                  </div>
 
                  <div class="col-md-2">
                    <label class="qm-label">Delivery Method</label>
                    <input type="text" class="qm-input" v-model="delivery_method" placeholder="Delivery method" />
                    <div v-if="errors.delivery_method" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.delivery_method[0] }}</div>
                  </div>
 
                </div>
              </div>
            </div>
 
            <!-- ── 2. Billing Address ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#f0fdf4;"><i class="ti ti-map-pin" style="color:#16a34a;"></i></div>
                <span class="qm-card-title">Billing Address</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
                  <div class="col-lg-3">
                    <label class="qm-label">Address</label>
                    <textarea class="qm-textarea" rows="2" v-model="address" placeholder="Full billing address..."></textarea>
                    <div v-if="errors.address" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.address[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">City</label>
                    <input type="text" class="qm-input" v-model="city" />
                    <div v-if="errors.city" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.city[0] }}</div>
                    <div class="form-check mt-2">
                      <input class="form-check-input" type="checkbox" name="is_shipping" id="is_shipping" v-model="is_shipping">
                      <label class="form-check-label" style="font-size:11px;" for="is_shipping">Add Shipping</label>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Zip Code</label>
                    <input type="text" class="qm-input" v-model="pincode" />
                    <div v-if="errors.pincode" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.pincode[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Country</label>
                    <vue-select v-model="country" :options="countries" label="name" placeholder="Select country"
                      @update:modelValue="onCountrySelect"/>
                    <div v-if="errors.country" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.country[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">State</label>
                    <vue-select v-model="state" :options="states" label="name" placeholder="Select state"/>
                    <div v-if="errors.state" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.state[0] }}</div>
                  </div>
                </div>
 
                <!-- Shipping Address -->
                <div class="row g-3 mt-3 pt-3 border-top" v-if="is_shipping">
                  <div class="col-12">
                    <span style="font-size:12px;font-weight:700;color:#0f172a;">
                      <i class="ti ti-truck-delivery me-1" style="color:#3b82f6;"></i>Shipping Address
                    </span>
                  </div>
                  <div class="col-lg-3">
                    <label class="qm-label">Shipping Address</label>
                    <textarea class="qm-textarea" rows="2" v-model="shipping_address" placeholder="Full shipping address..."></textarea>
                    <div v-if="errors.shipping_address" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.shipping_address[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Shipping City</label>
                    <input type="text" class="qm-input" v-model="shipping_city" />
                    <div v-if="errors.shipping_city" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.shipping_city[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Shipping Zip Code</label>
                    <input type="text" class="qm-input" v-model="shipping_pincode" />
                    <div v-if="errors.shipping_pincode" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.shipping_pincode[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Shipping Country</label>
                    <vue-select v-model="shipping_country" :options="countries" label="name" placeholder="Select country"
                      @update:modelValue="onShippingCountrySelect"/>
                    <div v-if="errors.shipping_country" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.shipping_country[0] }}</div>
                  </div>
                  <div class="col-lg-2">
                    <label class="qm-label">Shipping State</label>
                    <vue-select v-model="shipping_state" :options="shipping_states" label="name" placeholder="Select state"/>
                    <div v-if="errors.shipping_state" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.shipping_state[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── 3. Line Items ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                <span class="qm-card-title">Sales Order Items</span>
                <button type="button" class="qm-add-item-btn ms-auto" @click="addItemRow">
                  <i class="ti ti-plus"></i> Add Item
                </button>
              </div>
              <div class="qm-card-body">
 
                <div v-for="(item, index) in items" :key="index" class="qm-item-card">
                  <div class="qm-item-num">{{ index + 1 }}</div>
                  <input type="hidden" v-model="item.hsn_code" />
 
                  <div class="row g-2 align-items-end">
 
                    <div :class="tax_mode === 'item' ? 'col-md-3' : 'col-md-4'">
                      <label class="qm-label">Item</label>
                      <vue-select :options="allItems" label="name" v-model="item.item" :get-option-label="item => `${item.name} - ${item.code ?? item.id}`"
                        @update:modelValue="val => onItemSelected(index, val)" placeholder="Select item"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'item_id')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'item_id') }}
                      </div>
                    </div>
 
                    <div class="col-md-2" v-if="tax_mode === 'item'">
                      <label class="qm-label">Tax</label>
                      <vue-select :options="taxes" label="name" v-model="item.selectedTax" placeholder="Tax"
                        @update:modelValue="val => onItemTaxSelected(index, val)"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'tax_id')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'tax_id') }}
                      </div>
                    </div>
 
                    <div :class="tax_mode === 'item' ? 'col-md-2' : 'col-md-2'">
                      <label class="qm-label">Unit Cost</label>
                      <input type="number" class="qm-input" v-model.number="item.price" @input="updateAmount(index)" placeholder="0.00"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'unit_price')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'unit_price') }}
                      </div>
                    </div>
 
                    <div class="col-md-2">
                        <label class="qm-label">Unit</label>
                        <vue-select :options="item.availableUnits || standardUnits" label="label" :reduce="u => u" v-model="item.selectedUnit" placeholder="Unit"
                            @update:modelValue="val => onItemUnitSelected(index, val)"
                            :disabled="item.unit === 'Rmt'" />
                    </div>

                    <template v-if="item.calculation_type === 'dimensional'">
                        <div class="col-md-1">
                            <label class="qm-label">Width (mm)</label>
                            <input type="number" class="qm-input" v-model.number="item.width" @input="updateAmount(index)" placeholder="0" min="0" />
                        </div>
                        <div class="col-md-1">
                            <label class="qm-label">Height (mm)</label>
                            <input type="number" class="qm-input" v-model.number="item.height" @input="updateAmount(index)" placeholder="0" min="0" />
                        </div>
                        <div class="col-md-1">
                            <label class="qm-label">Size</label>
                            <input type="text" class="qm-input" :value="(item.size || 0).toFixed(4)" readonly
                                style="background:#f8fafc;font-weight:600;color:#1e293b;" />
                        </div>
                        <div class="col-12" v-if="getItemGeneralError(index)">
                            <div class="qm-err-msg" v-for="(err, i) in getItemGeneralError(index)" :key="i">
                                <i class="ti ti-alert-circle"></i>{{ err }}
                            </div>
                        </div>
                    </template>
 
                    <div class="col-md-1">
                      <label class="qm-label">Qty</label>
                      <input type="number" class="qm-input" v-model.number="item.qty" @input="updateAmount(index)" placeholder="1"/>
                      <div class="qm-err-msg" v-if="getItemError(index, 'quantity')">
                        <i class="ti ti-alert-circle"></i>{{ getItemError(index, 'quantity') }}
                      </div>
                    </div>
 
                    <div :class="tax_mode === 'item' ? 'col-md-1' : 'col-md-2'">
                      <label class="qm-label">Amount</label>
                      <input type="text" class="qm-input" :value="getItemAmountDisplay(item).toFixed(2)" readonly
                        style="background:#f8fafc;font-weight:700;color:#1e293b;" />
                    </div>
 
                    <div class="col-md-1 d-flex align-items-end">
                      <button type="button" class="qm-remove-btn" @click="removeItemRow(index)">
                        <i class="ti ti-trash"></i>
                      </button>
                    </div>
 
                    <div class="col-12">
                      <label class="qm-label">Description</label>
                      <ckeditor :ref="`itemEditor${index}`" :editor="editor" v-model="item.description" :config="editorConfig" tag-name="textarea"/>
                    </div>
 
                  </div>
                </div>
 
                <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                  <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                  No items added yet.
                </div>
 
              </div>
            </div>
 
            <!-- ── 4. QC Parameters ── -->
            <div class="qm-card" v-if="qcParameters.length && !qcLoading">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#faf5ff;"><i class="ti ti-clipboard-list" style="color:#8b5cf6;"></i></div>
                <span class="qm-card-title">QC Parameters</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
                  <div v-for="param in qcParameters" :key="param.id" class="col-lg-6 col-xl-4">
                    <label class="qm-label">
                      {{ param.name }}
                      <span v-if="param.is_required" class="req">*</span>
                    </label>
                    <small class="text-muted d-block mb-2" style="font-size:10px;">{{ param.description }}</small>
                    <input class="qm-input" v-model="qcChecklist[String(param.id)].value" placeholder="Enter value"/>
                    <div class="qm-err-msg" v-if="getQCError(param.id, 0)"><i class="ti ti-alert-circle"></i>{{ getQCError(param.id, 0) }}</div>
                  </div>
                </div>
              </div>
            </div>
 
            <!-- ── 5. Notes ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#faf5ff;"><i class="ti ti-notes" style="color:#8b5cf6;"></i></div>
                <span class="qm-card-title">Notes</span>
              </div>
              <div class="qm-card-body">
                <ckeditor :editor="editor" v-model="notes" :config="editorConfig"></ckeditor>
                <div class="qm-err-msg" v-if="errors.notes"><i class="ti ti-alert-circle"></i>{{ errors.notes[0] }}</div>
              </div>
            </div>
 
            <!-- ── 6. Pricing Summary ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#f0fdf4;"><i class="ti ti-calculator" style="color:#16a34a;"></i></div>
                <span class="qm-card-title">Pricing Summary</span>
              </div>
              <div class="qm-card-body">
                <div style="max-width:400px;margin-left:auto;">
 
                  <div class="qm-price-row">
                    <span class="qm-price-label">Subtotal</span>
                    <span class="qm-price-val">{{ currency }} {{ totalAmount.toFixed(2) }}</span>
                  </div>
 
                  <div class="qm-price-row" v-if="showTaxInfo && taxAmount">
                    <span class="qm-price-label">{{ tax_mode === 'order' ? 'Tax — ' + selectedTax?.name : 'Item Taxes' }}</span>
                    <span class="qm-price-val" style="color:#2563eb;">{{ currency }} {{ taxAmount.toFixed(2) }}</span>
                  </div>
 
                  <div class="qm-price-row">
                    <label class="qm-price-label mb-0">Discount</label>
                    <div class="qm-price-input-box">
                      <span class="qm-price-prefix">{{ currency || '₹' }}</span>
                      <input type="number" min="0" class="qm-price-num-input" v-model.number="discount" />
                    </div>
                  </div>
 
                  <div class="qm-price-row">
                    <label class="qm-price-label mb-0">Shipping Charges</label>
                    <div class="qm-price-input-box">
                      <span class="qm-price-prefix">{{ currency || '₹' }}</span>
                      <input type="number" min="0" class="qm-price-num-input" v-model.number="shipping_charges" />
                    </div>
                  </div>
 
                  <div class="qm-grand-box">
                    <div class="qm-grand-label"><i class="ti ti-check" style="font-size:13px;"></i> Grand Total</div>
                    <span class="qm-grand-val">{{ currency }} {{ grandTotal.toFixed(2) }}</span>
                  </div>
 
                </div>
              </div>
            </div>
 
          </div><!-- /qm-body -->
 
          <!-- Footer -->
          <div class="qm-footer">
            <button type="button" class="qm-btn qm-btn-ghost me-auto" @click="addItemRow">
              <i class="ti ti-plus"></i> Add Item
            </button>
 
            <!-- APPROVE BUTTON -->
            <button v-if="auth?.role?.is_sales_order_approver && status === 'draft'" type="button" class="qm-btn qm-btn-approve" @click="saveAndApprove">
              <i class="ti ti-circle-check"></i> Approve
            </button>
 
            <!-- REJECT BUTTON -->
            <button v-if="auth?.role?.is_sales_order_approver && status === 'draft'" type="button" class="qm-btn qm-btn-reject" @click="saveAndReject">
              <i class="ti ti-ban"></i> Reject
            </button>
 
            <button type="button" class="qm-btn qm-btn-success" @click="saveAndDownload">
              <i class="ti ti-download"></i> Save & Download
            </button>
            <button type="button" class="qm-btn qm-btn-primary" @click="save">
              <i class="ti ti-device-floppy"></i> Save
            </button>
          </div>
 
        </form>
      </div><!-- /qm-main -->
 
    </div>
  </div>
</div>
<!-- /ADD SALES ORDER MODAL -->
 
 
<!-- ═══════════════════════════════════════════════
     DELETE MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="sales_order_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-body" style="padding:32px 24px;text-align:center;">
  <div style="width:60px;height:60px;background:#fff0f3;border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;">
    <i class="ti ti-trash-x" style="font-size:26px;color:#f43f5e;"></i>
  </div>
  <h4 style="font-weight:700;color:#0f172a;margin-bottom:8px;">Delete Sales Order?</h4>
  <p style="color:#64748b;font-size:13px;margin-bottom:24px;">This action cannot be undone. All selected items will be permanently removed.</p>
  <div class="d-flex justify-content-center gap-3">
    <a href="javascript:void(0);" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="qm-btn qm-btn-danger" @click="deleteSalesOrder">
      <i class="ti ti-trash"></i> Yes, Delete
    </a>
  </div>
</div>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     ACTIVITY MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="quotation_activity_modal">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Activity Log</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <div class="modal-body" style="padding:18px;">
      <div v-if="activities.length">
        <div v-for="row in activities" :key="row.id"
          style="display:flex;align-items:flex-start;gap:12px;padding:10px 0;border-bottom:1px dashed #f1f5f9;">
          <div style="width:34px;height:34px;background:#fffbeb;border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <i class="ti ti-circle-dot" style="color:#f59e0b;font-size:13px;"></i>
          </div>
          <div>
            <p style="margin:0 0 3px;font-size:12.5px;color:#1e293b;font-weight:500;">{{ row.description }}</p>
            <p style="margin:0;font-size:11px;color:#94a3b8;"><i class="ti ti-clock-hour-3" style="margin-right:3px;"></i>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</p>
          </div>
        </div>
      </div>
      <div v-else style="text-align:center;padding:28px;color:#94a3b8;">
        <i class="ti ti-history" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
        No activity recorded yet.
      </div>
    </div>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     BULK ACTION MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="bulk_action_sales_order">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:#f8fafc;border-bottom:1px solid #e2e8f0;padding:13px 18px;">
      <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">Bulk Actions</h4>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="submitBulkAction">
      <div class="modal-body" style="padding:18px;">
        <div style="display:flex;align-items:center;gap:10px;padding:12px 14px;background:#fff0f3;border:1px solid #fecdd3;border-radius:10px;">
          <input type="checkbox" class="form-check-input" name="mass_delete" id="mass_delete" v-model="mass_delete"
            style="width:15px;height:15px;accent-color:#f43f5e;flex-shrink:0;margin-top:0;" />
          <div>
            <label for="mass_delete" style="font-size:12.5px;font-weight:600;color:#991b1b;cursor:pointer;margin:0;">Mass Delete</label>
            <div style="font-size:11px;color:#f87171;">Permanently remove all selected sales orders</div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 18px;gap:8px;">
        <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" class="qm-btn qm-btn-primary">Confirm</button>
      </div>
    </form>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     MAIL MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="sales_order_mail_modal">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
    <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
      <div>
        <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">{{ modal_title }}</h4>
        <div style="font-size:11px;color:#64748b;margin-top:1px;">Send this sales order via email</div>
      </div>
      <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close" style="filter:invert(1);opacity:.6;"><i class="ti ti-x"></i></button>
    </div>
    <form @submit.prevent="sendMail">
     <div class="modal-body" style="padding:20px;">
      <div class="mb-3"><DocumentPlaceholder/></div>
      <div class="mb-3">
        <label class="qm-label">To Email</label>
        <input type="text" class="qm-input" v-model="email" placeholder="recipient@email.com" />
        <div class="qm-err-msg" v-if="errors.email"><i class="ti ti-alert-circle"></i>{{ errors.email[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="qm-label">Email Subject</label>
        <input type="text" class="qm-input" v-model="settings.mail_subject" />
        <div class="qm-err-msg" v-if="errors.mail_subject"><i class="ti ti-alert-circle"></i>{{ errors.mail_subject[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="qm-label">Email Body</label>
        <ckeditor :editor="editor" v-model="settings.mail_body" :config="editorConfig"></ckeditor>
        <div class="qm-err-msg" v-if="errors.mail_body"><i class="ti ti-alert-circle"></i>{{ errors.mail_body[0] }}</div>
      </div>
      <div class="mb-3">
        <label class="qm-label">Email Footer</label>
        <ckeditor :editor="editor" v-model="settings.mail_footer" :config="editorConfig"></ckeditor>
        <div class="qm-err-msg" v-if="errors.mail_footer"><i class="ti ti-alert-circle"></i>{{ errors.mail_footer[0] }}</div>
      </div>
     </div>
     <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
      <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">Cancel</button>
      <button type="submit" class="qm-btn qm-btn-primary"><i class="ti ti-send"></i> Send Email</button>
     </div>
    </form>
  </div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     VIEW DETAILS MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="sales_order_detail_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
<div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
  <h4 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">Sales Order Detail</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close" style="filter:invert(1);opacity:.6;"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body" style="padding:20px;">
 
<div style="display:flex;gap:12px;margin-bottom:16px;">
  <div style="flex:1;text-align:center;background:#f8fafc;border-radius:10px;padding:12px 8px;">
    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">SO No</div>
    <div style="font-size:13px;font-weight:700;color:#0f172a;">{{ so_number }}</div>
  </div>
  <div style="flex:1;text-align:center;background:#f8fafc;border-radius:10px;padding:12px 8px;">
    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">Status</div>
    <div><StatusBadge :status="status"></StatusBadge></div>
  </div>
  <div style="flex:1;text-align:center;background:#f8fafc;border-radius:10px;padding:12px 8px;">
    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">Tracking No</div>
    <span style="font-size:11px;font-weight:600;color:#be185d;background:#fdf2f8;padding:2px 8px;border-radius:20px;">{{ tracking_number ?? 'N/A' }}</span>
  </div>
</div>
 
<div v-if="remark" style="background:#fff0f3;border:1px solid #fecdd3;border-radius:10px;padding:12px 14px;margin-bottom:16px;">
  <p style="margin:0;font-size:12.5px;color:#991b1b;" v-html="remark"></p>
</div>
 
<div class="schedule-timeline">
  <div class="d-flex align-items-center" v-if="dispatched_at">
    <div class="d-flex align-items-center active-time"><span class="timeline-date text-dark">{{ $formatDate(dispatched_at) }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
    <div class="flex-fill ps-3 pb-4 timeline-hrline">
      <div class="mt-4">
        <p class="fw-medium text-gray-9 mb-1"><span style="padding:2px 10px;background:#f0fdf4;color:#16a34a;border-radius:20px;font-size:10px;font-weight:600;">Dispatched At</span></p>
      </div>
    </div>
  </div>
 
  <div class="d-flex align-items-center" v-if="completed_at">
    <div class="d-flex align-items-center active-time"><span class="timeline-date text-dark">{{ $formatDate(completed_at) }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
    <div class="flex-fill ps-3 pb-4 timeline-hrline">
      <div class="mt-4">
        <p class="fw-medium text-gray-9 mb-1"><span style="padding:2px 10px;background:#f0fdf4;color:#16a34a;border-radius:20px;font-size:10px;font-weight:600;">Completed At</span></p>
      </div>
    </div>
  </div>
 
  <div class="d-flex align-items-center">
    <div class="flex-fill ps-3 pb-0 timeline-hrline"></div>
  </div>
</div>
 
<div v-if="activities?.length">
  <div v-for="row in activities" :key="row.id"
    style="display:flex;align-items:flex-start;gap:12px;padding:10px 0;border-bottom:1px dashed #f1f5f9;">
    <div style="width:34px;height:34px;background:#fffbeb;border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
      <i class="ti ti-circle-dot" style="color:#f59e0b;font-size:13px;"></i>
    </div>
    <div>
      <p style="margin:0 0 3px;font-size:12.5px;color:#1e293b;font-weight:500;" v-html="row.description"></p>
      <p style="margin:0;font-size:11px;color:#94a3b8;"><i class="ti ti-clock-hour-3" style="margin-right:3px;"></i>{{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</p>
    </div>
  </div>
</div>
 
<div v-else style="text-align:center;padding:28px;color:#94a3b8;">
  <i class="ti ti-history" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
  No activity recorded yet.
</div>
 
</div>
</div>
</div>
</div>
 
 
<!-- ═══════════════════════════════════════════════
     QC STATUS MODAL
═══════════════════════════════════════════════ -->
<div class="modal fade" id="sales_order_qc_status_modal" tabindex="-1" aria-hidden="true">
<div class="modal-dialog modal-xl modal-dialog-scrollable">
<div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
 
<!-- Header -->
<div class="modal-header" :style="is_editable
  ? 'background:linear-gradient(135deg,#f0fdf4,#dcfce7);padding:15px 20px;border:none;'
  : 'background:linear-gradient(135deg,#eff6ff,#dbeafe);padding:15px 20px;border:none;'">
  <div class="d-flex align-items-center">
    <div style="width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;margin-right:10px;"
      :style="is_editable ? 'background:rgba(22,163,74,.15);' : 'background:rgba(59,130,246,.15);'">
      <i :class="is_editable ? 'ti ti-clipboard-check' : 'ti ti-eye'"
        :style="is_editable ? 'color:#16a34a;font-size:18px;' : 'color:#3b82f6;font-size:18px;'"></i>
    </div>
    <div>
      <h5 style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">
        {{ is_editable ? 'Edit QC Status' : 'View QC Status' }} — {{ so_number }}
      </h5>
      <small style="font-size:11px;color:#64748b;">
        {{ completionPercentage }}% Complete ({{ savedQCCount }}/{{ qcItems.length }})
      </small>
    </div>
  </div>
  <button type="button" class="qm-close-btn ms-auto" data-bs-dismiss="modal" @click="resetQCForm">
    <i class="ti ti-x"></i>
  </button>
</div>
 
<!-- Body -->
<div class="modal-body" style="padding:20px;">
 
  <!-- Loading -->
  <div v-if="qcLoading" style="text-align:center;padding:40px;">
    <div class="spinner-border text-success mb-3" role="status"></div>
    <h6 style="color:#64748b;">Loading items...</h6>
  </div>
 
  <!-- No Items -->
  <div v-else-if="!qcItems.length" style="text-align:center;padding:40px;color:#94a3b8;">
    <i class="ti ti-clipboard-x" style="font-size:36px;opacity:.4;display:block;margin-bottom:10px;"></i>
    <h5 style="font-weight:600;">No Items Found</h5>
  </div>
 
  <!-- Items List -->
  <template v-else>
 
    <!-- Summary Stats -->
    <div class="row g-3 mb-4">
      <div class="col-6 col-lg-3">
        <div style="background:#f0fdf4;border-radius:10px;padding:14px;text-align:center;">
          <div style="font-size:22px;font-weight:800;color:#16a34a;">{{ savedQCCount }}</div>
          <div style="font-size:10px;font-weight:600;color:#64748b;">Checked</div>
        </div>
      </div>
      <div class="col-6 col-lg-3">
        <div style="background:#fffbeb;border-radius:10px;padding:14px;text-align:center;">
          <div style="font-size:22px;font-weight:800;color:#f59e0b;">{{ pendingQCCount }}</div>
          <div style="font-size:10px;font-weight:600;color:#64748b;">Pending</div>
        </div>
      </div>
      <div class="col-6 col-lg-3">
        <div style="background:#eff6ff;border-radius:10px;padding:14px;text-align:center;">
          <div style="font-size:22px;font-weight:800;color:#3b82f6;">{{ qcItems.length }}</div>
          <div style="font-size:10px;font-weight:600;color:#64748b;">Total</div>
        </div>
      </div>
      <div class="col-6 col-lg-3">
        <div style="background:#faf5ff;border-radius:10px;padding:14px;text-align:center;">
          <div style="font-size:22px;font-weight:800;color:#8b5cf6;">{{ completionPercentage }}%</div>
          <div style="font-size:10px;font-weight:600;color:#64748b;">Complete</div>
        </div>
      </div>
    </div>
 
    <!-- Items Loop -->
    <div v-for="(item, index) in qcItems" :key="item.id"
      style="margin-bottom:8px;border-radius:10px;overflow:hidden;"
      :style="item.is_checked
        ? 'border:1.5px solid #bbf7d0;border-left:3px solid #16a34a;'
        : 'border:1.5px solid #fed7aa;border-left:3px solid #f59e0b;'">
 
      <!-- Main Row -->
      <div class="d-flex align-items-center gap-3 px-3 py-2" style="background:#fff;">
 
        <!-- Dot -->
        <div :style="item.is_checked
          ? 'width:8px;height:8px;border-radius:50%;background:#16a34a;flex-shrink:0;'
          : 'width:8px;height:8px;border-radius:50%;background:#f59e0b;flex-shrink:0;'">
        </div>
 
        <!-- Item Info -->
        <div class="flex-grow-1">
          <span style="font-size:12.5px;font-weight:600;color:#0f172a;">{{ item.name }}</span>
          <div style="font-size:11px;color:#94a3b8;" v-html="item.description"></div>
        </div>
 
        <!-- Qty & Unit -->
        <div style="text-align:center;min-width:80px;">
          <span style="font-size:11px;font-weight:600;color:#1e293b;background:#f1f5f9;padding:2px 8px;border-radius:5px;">Qty: {{ item.qty }}</span>
          <div style="font-size:10px;color:#94a3b8;margin-top:2px;">{{ item.unit }}</div>
        </div>
 
        <!-- Status Badge -->
        <span style="font-size:10px;font-weight:600;padding:3px 10px;border-radius:20px;"
          :style="item.is_checked
            ? 'background:#f0fdf4;color:#16a34a;'
            : 'background:#fffbeb;color:#f59e0b;'">
          {{ item.is_checked ? '✓ Checked' : '⏳ Pending' }}
        </span>
 
        <!-- Toggle Checkbox -->
        <div class="form-check form-switch form-switch-sm mb-0">
          <input class="form-check-input" type="checkbox"
            :checked="item.is_checked"
            @change="updateQCItem(index, 'is_checked', $event.target.checked)"
            :disabled="!is_editable" />
        </div>
 
      </div>
 
      <!-- Remark Row -->
      <div v-if="!item.is_checked" class="px-3 py-2"
        style="background:#fffdf5;border-top:1px solid #f1f5f9;">
        <label style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;display:block;">
          <i class="ti ti-message me-1"></i>Remark
        </label>
        <textarea class="qm-textarea" rows="2"
          :value="item.remark"
          @input="updateQCItem(index, 'remark', $event.target.value)"
          :readonly="!is_editable"
          :placeholder="!is_editable ? 'No remark' : 'Optional remark...'">
        </textarea>
      </div>
 
    </div>
 
  </template>
 
  <!-- Delivery Image Section (Editable) -->
  <div class="mt-4 pt-4 border-top" v-if="is_editable">
    <div class="qm-card" style="margin-bottom:0;">
      <div class="qm-card-head">
        <div class="qm-card-icon" style="background:#faf5ff;"><i class="ti ti-camera" style="color:#8b5cf6;"></i></div>
        <span class="qm-card-title">Delivery Image Upload</span>
      </div>
      <div class="qm-card-body" style="text-align:center;">
        <small class="text-muted d-block mb-3" style="font-size:10px;">Upload delivery proof photo (Optional)</small>
        <div v-if="deliveryImage" class="mb-3">
          <img :src="deliveryImage" style="max-height:200px;max-width:300px;border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,.1);" alt="Delivery image">
          <div class="mt-2">
            <button @click="removeDeliveryImage" class="qm-btn qm-btn-danger" style="padding:5px 12px;font-size:11px;">
              <i class="ti ti-trash"></i> Remove
            </button>
          </div>
        </div>
        <div v-else style="padding:30px;border:2px dashed #93c5fd;border-radius:12px;background:#f8fafc;cursor:pointer;"
          @click="$refs.deliveryImageInput.click()"
          @dragover.prevent @dragenter.prevent @drop.prevent="handleImageDrop">
          <input ref="deliveryImageInput" type="file" accept="image/*" style="display:none;" @change="handleDeliveryImageUpload">
          <i class="ti ti-upload" style="font-size:28px;color:#3b82f6;display:block;margin-bottom:8px;"></i>
          <div style="font-size:12px;font-weight:600;color:#2563eb;">Drop image here or click to browse</div>
          <div style="font-size:10px;color:#94a3b8;margin-top:4px;">JPEG, JPG, PNG, WEBP (Max 5MB)</div>
          <div v-if="deliveryImageUploading" class="mt-3">
            <div class="progress" style="height:6px;">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                :style="{width: deliveryUploadProgress + '%'}"></div>
            </div>
            <small style="color:#16a34a;font-size:10px;">{{ deliveryUploadProgress }}%</small>
          </div>
        </div>
        <div v-if="deliveryImageError" style="margin-top:10px;padding:10px 14px;background:#fff0f3;border:1px solid #fecdd3;border-radius:8px;color:#f43f5e;font-size:11px;">
          {{ deliveryImageError }}
        </div>
      </div>
    </div>
  </div>
 
  <!-- View Mode: Show existing image -->
  <div v-else-if="!is_editable && deliveryImage" class="mt-4 pt-4 border-top">
    <div class="qm-card" style="margin-bottom:0;">
      <div class="qm-card-head">
        <div class="qm-card-icon" style="background:#eff6ff;"><i class="ti ti-camera" style="color:#3b82f6;"></i></div>
        <span class="qm-card-title">Delivery Image</span>
      </div>
      <div class="qm-card-body" style="text-align:center;">
        <img :src="deliveryImage" style="max-height:200px;border-radius:10px;box-shadow:0 2px 10px rgba(0,0,0,.1);" alt="Delivery image">
      </div>
    </div>
  </div>
 
</div>
 
<!-- Footer -->
<div style="background:#f8fafc;border-top:1px solid #e2e8f0;padding:11px 20px;display:flex;align-items:center;justify-content:flex-end;gap:8px;">
  <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal" @click="resetQCForm">
    <i class="ti ti-x"></i> {{ is_editable ? 'Cancel' : 'Close' }}
  </button>
  <button v-if="is_editable" type="button" class="qm-btn" style="background:#fff;color:#f59e0b;border-color:#fcd34d;" @click="saveQCAndUpdateStatus" :disabled="qcLoading">
    <i class="ti ti-progress"></i> Update Status
  </button>
  <button v-if="is_editable" type="button" class="qm-btn qm-btn-approve" @click="saveQCStatus" :disabled="qcLoading">
    <i class="ti ti-device-floppy"></i> Save QC Status
  </button>
</div>
 
</div>
</div>
</div>
<!-- /QC Status Modal -->
 
</template>